import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react"

const config = defineConfig({
  theme: {
    recipes: {
      button: {
        base: {
          color: "white",
        },
      },
    },
  },
})

export const system = createSystem(defaultConfig, config)
